import axios from "axios";
import { Constants } from "../utils/constants"


export const generateToken = async () => {
    const token = await axios.post(Constants.URL.base + Constants.URL.auth, {
        grant_type: 'client_credentials',
        client_secret: Constants.client.secret,
        client_id: Constants.client.id
    }, {
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        },
    })
        .then(data => data?.data)
        .catch(error => {
            console.debug(error)
        });
    return token
}






  
 


  